/**
 * Redux slice for dynamic tabs state.
 *
 * Manages:
 * - Tab configuration fetched from API based on patient status
 * - Loading and error states for tabs data
 *
 * Pattern: Uses createAsyncThunk for data fetching (same as timelineSlice).
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchTabs } from '../../services/tabsService';
const initialState = {
    tabs: [],
    loading: false,
    error: null
};
/**
 * Async thunk to fetch tab configuration for a patient
 */
export const fetchPatientTabs = createAsyncThunk('tabs/fetchPatientTabs', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ pageName, patientId }, { rejectWithValue }) {
    try {
        const response = yield fetchTabs(pageName, patientId);
        return response.components.PatientDashboard;
    }
    catch (error) {
        const errorMessage = error instanceof Error ? error.message : 'Failed to fetch tabs';
        return rejectWithValue(errorMessage);
    }
}));
const tabsSlice = createSlice({
    name: 'tabs',
    initialState,
    reducers: {
        clearTabs: () => {
            return Object.assign({}, initialState);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPatientTabs.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchPatientTabs.fulfilled, (state, action) => {
            state.tabs = action.payload;
            state.loading = false;
            state.error = null;
        })
            .addCase(fetchPatientTabs.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = false;
        });
    }
});
export const { clearTabs } = tabsSlice.actions;
export default tabsSlice.reducer;
